import { css } from '@emotion/react';

const nestedChecklistExpandArrow = css({
  fontSize: '1.35em',
});

const alertClose = css({
  '&&&': {
    fontSize: '1.429em',
  },
});

const selectDown = css({
  fontSize: '1.5em',
});

const comboBoxClear = css({
  fontSize: '1.25em',
});

const modalClose = css({
  fontSize: '1.5rem',
});

export const S = {
  nestedChecklistExpandArrow,
  alertClose,
  selectDown,
  comboBoxClear,
  modalClose,
} as const;
